/**
 * Standardizes the Apollo mutate contract for predictable, App usage.
 * @param {Object} apolloClient The created apollo client for a particular module
 * @returns {Function} A function that calls Apollo's mutate and maps the result to App's specifications (https://www.apollographql.com/docs/react/api/core/ApolloClient/#ApolloClient.mutate)
 */
const mutate = (apolloClient) => {
  /**
   * Generic function. Does a GraphQL mutate and standardizes the response
   * @param {Object} q GraphQL mutation to execute
   * @param {Object} variables GraphQL variables for the query
   * @param {String} resultKey The property to drill down on in the GraphQL result object
   * @param {Object} options Options to pass to the GraphQL mutation
   * @returns {Promise} A standardized response containing an object of the following: {errors, loading, data}
   */
  return async (mutation, variables, resultKey, options) => {
    const { data, errors, loading } = await apolloClient
      .mutate({
        mutation,
        variables,
        options,
      })
      .catch((err) => ({ errors: err }));

    return {
      errors,
      loading,
      data: data && data[resultKey],
    };
  };
};

export default mutate;
